import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface ChestNumberRange {
  id: string;
  organizationId: string;
  gradeCategory: string;
  rangeStart: number;
  rangeEnd: number;
  nextNumber: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateChestNumberRangeInput {
  gradeCategory: string;
  rangeStart: number;
  rangeEnd: number;
  organizationId?: string;
}

export interface UpdateChestNumberRangeInput {
  rangeStart?: number;
  rangeEnd?: number;
}

export const ChestNumberRangesApi = {
  list: async (organizationId?: string): Promise<ChestNumberRange[]> =>
    unwrap(await api.get('/superadmin/chest-number-ranges', { params: organizationId ? { organizationId } : undefined })),
  create: async (data: CreateChestNumberRangeInput): Promise<ChestNumberRange> =>
    unwrap(await api.post('/superadmin/chest-number-ranges', data)),
  update: async (id: string, data: UpdateChestNumberRangeInput): Promise<ChestNumberRange> =>
    unwrap(await api.patch(`/superadmin/chest-number-ranges/${id}`, data)),
  remove: async (id: string) => unwrap(await api.delete(`/superadmin/chest-number-ranges/${id}`)),
};
